import React, { ButtonHTMLAttributes, forwardRef } from "react";
import styled from "styled-components";

/* ex
<CustomButton
  label="제출하기"
  type="submit"
  fullWidth
  variant="primary"
  isLoading={isSubmitting}
/>

<CustomButton
  onClick={() => alert("삭제!")}
  variant="danger"
>
  삭제
</CustomButton>
*/

type CustomButtonProps = {
  label?: string;
  variant?: "primary" | "secondary" | "danger";
  fullWidth?: boolean;
  isLoading?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const CustomButton = forwardRef<HTMLButtonElement, CustomButtonProps>(
  ({ label, variant = "primary", fullWidth, isLoading, children, ...rest }, ref) => {
    return (
      <StyledButton
        ref={ref}
        variant={variant}
        fullWidth={fullWidth}
        disabled={isLoading || rest.disabled}
        {...rest}
      >
        {isLoading ? "로딩 중..." : children || label}
      </StyledButton>
    );
  }
);

CustomButton.displayName = "CustomButton";

export default CustomButton;

const StyledButton = styled.button<{
  variant: "primary" | "secondary" | "danger";
  fullWidth?: boolean;
}>`
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "auto")};
  color: #fff;
  background-color: ${({ variant }) => {
    switch (variant) {
      case "primary":
        return "#007bff";
      case "secondary":
        return "#6c757d";
      case "danger":
        return "#dc3545";
      default:
        return "#007bff";
    }
  }};
  &:hover {
    background-color: ${({ variant }) => {
      switch (variant) {
        case "primary":
          return "#0056b3";
        case "secondary":
          return "#5a6268";
        case "danger":
          return "#c82333";
        default:
          return "#0056b3";
      }
    }};

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
